import { __rest, __assign } from 'tslib';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { forwardRef, useRef } from 'react';
import { DisclosureArrowIcon } from '../../Disclosure/DisclosureArrowIcon.js';
import { DisclosureContent } from '../../Disclosure/DisclosureContent.js';
import { DisclosureProvider } from '../../Disclosure/DisclosureProvider.js';
import { useComposedRefs } from '../../hooks/useComposedRefs.js';
import { useTheme } from '../../hooks/useTheme.js';
import { Grid } from '../../Grid/index.js';
import { MainNavButton } from '../MainNavButton/MainNavButton.js';
import { MainNavMenuItems } from './MainNavMenuItems.js';
import { useMainNavMenu } from './useMainNavMenu.js';

var MainNavMenuAsButton = forwardRef(function (_a, forwardedRef) {
    var children = _a.children, _b = _a.currentIsOpen, currentIsOpen = _b === void 0 ? true : _b, _c = _a.defaultIsOpen, defaultIsOpen = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, decor = _a.decor, description = _a.description, noDecor = _a.noDecor, icon = _a.icon, idProp = _a.id, label = _a.label, notify = _a.notify, onClickProp = _a.onClick, props = __rest(_a, ["children", "currentIsOpen", "defaultIsOpen", "disabled", "decor", "description", "noDecor", "icon", "id", "label", "notify", "onClick"]);
    var triggerRef = useRef(null);
    var ref = useComposedRefs(triggerRef, forwardedRef);
    var _e = useMainNavMenu({
        currentIsOpen: currentIsOpen,
        defaultIsOpen: defaultIsOpen,
        triggerRef: triggerRef,
        id: idProp,
    }), disclosure = _e.disclosure, itemsRef = _e.itemsRef, themeKey = _e.themeKey;
    var handleStyleProps = useTheme().handleStyleProps;
    var forwardProps = handleStyleProps(__assign({ disabled: disabled }, props), { themeKey: "".concat(themeKey, "Menu") });
    var isOpen = disclosure.isOpen, toggleIsOpen = disclosure.toggleIsOpen, id = disclosure.id;
    var onClick = function (event) {
        onClickProp && onClickProp(event);
        if (!event.defaultPrevented) {
            event.preventDefault();
            toggleIsOpen();
        }
    };
    return (jsx(Grid, __assign({ sx: { gridTemplateColumns: "1fr" } }, { children: jsxs(DisclosureProvider, __assign({ value: disclosure }, { children: [jsx(MainNavButton, __assign({ "data-nav-item": true, "data-is-open": isOpen, ref: ref, onClick: onClick, "aria-controls": id, "aria-expanded": isOpen, "data-disabled": disabled, description: description, icon: icon, label: label, decor: !noDecor && (decor || jsx(DisclosureArrowIcon, {})), notify: notify }, forwardProps)), jsx(DisclosureContent, { children: jsx(MainNavMenuItems, __assign({ ref: itemsRef }, { children: children })) })] })) })));
});
MainNavMenuAsButton.displayName = "MainNavMenuAsButton";

export { MainNavMenuAsButton };
//# sourceMappingURL=MainNavMenuAsButton.js.map
